import { events as wbEvents } from '@waybetter/wb-analytics';

export const events = {
  ...wbEvents,
  BUTTON_CLICK: 'Clicked',
  PASSWORD_VALIDATED: 'Password Validated',
  EXIT_INTENT: 'Exit Intent',
  EXIT_POP_SIGNED_UP: 'Exit Pop Signed Up',
  ACCOUNT_DELETED: 'Account Deletion Requested',

  PROSPECT_EMAIL_CHANGE: 'Prospect Email Change',
  PROSPECT_EMAIL_CHANGE_ERROR: 'Prospect Email Change Error',

  PAYMENT_METHOD_READY: 'Payment Method Ready',
  PAYMENT_ERROR: 'Payment Error',
  REFERRAL_MAGIC_LINK_CREATED: 'Referral Magic Link Created',
  HELP_WIDGET: 'Help Widget',

  // A visitor sent her number from a host's text club page and was signed up
  // (the conversion). Never carries the phone number.
  TEXT_CLUB_PHONE_SUBMITTED: 'Text Club Phone Submitted',
};
